/* defer-jquery flush — runs (defer, in order) right after the deferred
 * jquery-3.7.1.min.js replaced the parse-time stub. Replays every callback
 * the stub queued ($(fn) / $(document).ready(fn) from inline scripts)
 * through real jQuery, which fires them on DOM ready as normal. */
(function () {
  'use strict';
  var q = window.__tsoJQQueue;
  if (!q || !window.jQuery || window.jQuery.__tsoStub) return;
  window.__tsoJQQueue = null;
  for (var i = 0; i < q.length; i++) {
    try { window.jQuery(q[i]); } catch (e) {
      try { console.error('[defer-jquery] queued callback failed', e); } catch (e2) {}
    }
  }
})();
